import { Box, Typography, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { accessibleChartTitleSx } from './chartAccessibleText';

export default function AccessibleChartTitle({
  id,
  text,
  fontSize,
  sx,
}: {
  id: string;
  text: string | string[];
  fontSize?: number | { xs?: number; sm?: number };
  sx?: SxProps<Theme>;
}): JSX.Element {
  const lines = Array.isArray(text) ? text : [text];

  return (
    <Typography
      component="h2"
      variant="body1"
      id={id}
      className="chart-accessible-title"
      sx={{
        ...accessibleChartTitleSx,
        fontSize: fontSize ?? { xs: 10, sm: 12 },
        ...sx,
      }}>
      {lines.map((line, index) => (
        <Box
          component="span"
          key={index}
          className="chart-title-line"
          sx={{
            display: 'block',
            ...(index > 0 ? { mt: '2em' } : {}),
          }}>
          {line}
        </Box>
      ))}
    </Typography>
  );
}
